/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
// import { DATA_ICON, MR_ICON, ZONE_ICON } from '../../../../../public/media/index'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='./image/Dashboard.svg'
        ActiveIcon='./image/ActiveDashboard.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      />
      <AsideMenuItem
        to='/zone_management'
        icon='./image/Zone.svg'
        ActiveIcon='./image/ActiveZone.svg'
        title='Zone Management'
      />
      <AsideMenuItem
        to='/doctor_list'
        icon="./image/Doctor.svg"
        ActiveIcon='./image/ActiveDoctor.svg'
        title='Doctor List'
      />
      <AsideMenuItem
        to='/mr_list'
        icon="./image/MR.svg"
        ActiveIcon='./image/ActiveMR.svg'
        title='MR List'
      />
      <AsideMenuItem
        to='/data'
        icon='./image/Data.svg'
        ActiveIcon='./image/ActiveData.svg'
        title='Submission Data'
      />
    </>
  )
}
